module.exports = __webpack_public_path__ + "static/img/mould3-1.39cbe10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/mould/mould3-1.png
// module id = IbGA
// module chunks = 3